import React from 'react';
import { useTranslation } from 'react-i18next';

export type KeySearchMode = 'code' | 'tag';

export interface KeySearchModeSwitcherProps {
  mode: KeySearchMode;
  onModeChange: (mode: KeySearchMode) => void;
}

function KeySearchModeSwitcher({ mode, onModeChange }: KeySearchModeSwitcherProps) {
  const { t } = useTranslation();

  return (
    <div className="mb-3" role="group" aria-label={t('Search mode')}>
      <button
        type="button"
        className={`btn btn-${
          mode === 'code' ? 'primary' : 'default'
        } btn-outline r-corners-left`}
        onClick={() => onModeChange('code')}
        aria-pressed={mode === 'code'}
        title={t('Key')}
      >
        {t('Key')}
      </button>
      <button
        type="button"
        className={`btn btn-${
          mode === 'tag' ? 'primary' : 'default'
        } btn-outline r-corners-right`}
        onClick={() => onModeChange('tag')}
        aria-pressed={mode === 'tag'}
        title={t('Tag')}
      >
        {t('Tag')}
      </button>
    </div>
  );
}

export default KeySearchModeSwitcher;